import $ from "jquery";

// Lazy load foreground images (<img> tags in HTML)
/* istanbul ignore next */
function lazyLoadForegroundImages(): void {
  if ($(".js-lazy-load").length) {
    if (typeof IntersectionObserver !== "undefined") {
      const callback = function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            const $entryTarget = $(entry.target);
            const src = $entryTarget.data("src");
            $entryTarget.attr("src", src);
          }
        });
      };

      const options = {
        rootMargin: "0px",
        threshold: 0,
      };

      const observer = new IntersectionObserver(callback, options);
      $(".js-lazy-load").each(function () {
        observer.observe($(this)[0]);
      });
    } else {
      // Fallback for browsers which do not support InteractionObserver
      $(".js-lazy-load").each(function () {
        const $this = $(this);
        const src = $this.data("src");
        $this.attr("src", src);
      });
    }
  }
}

// Lazy load background images (background-image:url() rules in CSS)
/* istanbul ignore next */
function lazyLoadBackgroundImages(): void {
  if ($(".js-lazy-load-background").length) {
    if (typeof IntersectionObserver !== "undefined") {
      const bgcallback = function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            const $entryTarget = $(entry.target);
            const bg = $entryTarget.data("background");
            $entryTarget.css("background-image", "url(" + bg + ")");
          }
        });
      };

      const bgoptions = {
        rootMargin: "0px",
        threshold: 0,
      };

      const bgobserver = new IntersectionObserver(bgcallback, bgoptions);
      $(".js-lazy-load-background").each(function () {
        bgobserver.observe($(this)[0]);
      });
    } else {
      // Fallback for browsers which do not support InteractionObserver
      $(".js-lazy-load-background").each(function () {
        const $this = $(this);
        const bg = $this.data("background");
        $this.css("background-image", "url(" + bg + ")");
      });
    }
  }
}

export default { lazyLoadForegroundImages, lazyLoadBackgroundImages };
